import notificationService from "./notification.service";
import LocalStorageService from "./local-storage.service";
import { create } from "apisauce";
import utilService from "./utils.service";
import AuthService from "./auth.service";
import { STORAGE_CONST } from "../constants/constant";
import { unAuthenticatedRoutes } from "../routes/constant";
const role = AuthService.getRole();

const apiServiceV2 = {
    apiSauceInstance: create({
        baseURL: role ? utilService.apiUrl : utilService.apiUrlV2,
    }),
    post,
    get,
    put,
    patch,
    _delete,
    handleResponse: handleResponse,
};


function setBaseUrl (useV1 = true) {    
    return apiServiceV2.apiSauceInstance?.setBaseURL?.(useV1 ? utilService.apiUrl: utilService.apiUrlV2)
}

async function get(url, queryParams, config) {
    const response = await apiServiceV2.apiSauceInstance.get(
        url,
        queryParams,
        config
    );
    return apiServiceV2.handleResponse(response);
}

async function post(url, data, config) {
    const response = await apiServiceV2.apiSauceInstance.post(
        url,
        data,
        config
    );
    return apiServiceV2.handleResponse(response);
}

async function put(url, data, config) {
    const response = await apiServiceV2.apiSauceInstance.put(url, data, config);
    return apiServiceV2.handleResponse(response);
}

async function _delete(url, data, config) {
    const response = await apiServiceV2.apiSauceInstance.delete(
        url,
        data,
        config
    );
    return apiServiceV2.handleResponse(response);
}

async function patch(url, data, config) {
    const response = await apiServiceV2.apiSauceInstance.patch(
        url,
        data,
        config
    );
    return apiServiceV2.handleResponse(response);
}

function handleResponse(response) {
    const mutatedResponse = {
        ok: response.ok,
        status: response.status,
        response: {
            code: utilService.getValue(response.data, "response.code", 500),
            message: utilService.getValue(
                response.data,
                "message",
                "Something went wrong"
            ),
            errorCode: utilService.getValue(
                response.data,
                "response.errorCode",
                400
            ),
        },
    };
    const data = utilService.getValue(response.data, "data", response.data);
    if (response.status === 401) {
        LocalStorageService.remove(STORAGE_CONST.USER_INFO);
        setTimeout(() => {
            return utilService.redirectTo(unAuthenticatedRoutes.LOGIN);
        }, 2000);
        return {
            ...mutatedResponse,
            data: !utilService.isEmpty(data) ? data : null,
        };
    }
    if (response.status === 500) {
        notificationService.error("Something went wrong");
        return {
            ...mutatedResponse,
            data: !utilService.isEmpty(data) ? data : null,
        };
    }
    if (response.ok) {
        return { ...mutatedResponse, data, allData: response.data };
    } else {
        return {
            ...mutatedResponse,
            data: !utilService.isEmpty(data) ? data : null,
        };
    }
}

apiServiceV2.apiSauceInstance.addRequestTransform((request) => {
    request.headers["Authorization"] = `Bearer ${AuthService.getToken()}`;
    request.headers["ngrok-skip-browser-warning"] = true;
    request.headers["skip_zrok_interstitial"] = true; //dev-mode only
});

export default {
    post: apiServiceV2.post,
    get: apiServiceV2.get,
    patch: apiServiceV2.patch,
    put: apiServiceV2.put,
    delete: apiServiceV2._delete,
    setBaseUrl
};
